<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Roles</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllRolesTable></AllRolesTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Bank Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Roles",
    meta: [{ name: "Roles", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Roles",

      items: [
        {
          text: "Role",
          href: "/"
        },
        {
          text: "Roles",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
